"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const Row_1 = require("../components/Row");
const ExperienceSelector_1 = require("./ExperienceSelector");
const actions_1 = require("../../../actions");
const reducers_1 = require("../../../reducers");
const PopoverTextRadioButtonComponent_1 = require("../../utils/PopoverTextRadioButtonComponent");
const MobilePopover_1 = require("../components/MobilePopover");
class TapBehaviorBody extends React.Component {
    constructor(props) {
        super(props);
        this.POPOVER_ID = 'web-presentation-type-selector';
        this.state = {
            urlContentEditable: false,
        };
        this.handleDeepLinkChange = this.handleDeepLinkChange.bind(this);
        this.handleSelectPresentationType = this.handleSelectPresentationType.bind(this);
        this.handleURLChange = this.handleURLChange.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.selectedTapOption !== nextProps.selectedTapOption) {
            this.setState({
                urlContentEditable: false,
            });
        }
    }
    handleDeepLinkChange(text) {
        const { tapBehavior, updateNotificationDeliverable } = this.props;
        const url = text.trim();
        updateNotificationDeliverable({
            tapBehavior: {
                type: 'OPEN_URL',
                url,
            },
        });
        this.setState({ urlContentEditable: false });
    }
    handleURLChange(text) {
        const { tapBehavior, updateNotificationDeliverable } = this.props;
        const url = this.sanitizeURL(text.trim());
        updateNotificationDeliverable({
            tapBehavior: Object.assign(Object.assign({}, tapBehavior), { url }),
        });
        this.setState({ urlContentEditable: false });
    }
    sanitizeURL(url) {
        if (url === 'https://' || url === 'http://') {
            return url;
        }
        const isURL = (u) => {
            try {
                const testURL = new URL(u);
            }
            catch (err) {
                return false;
            }
            return true;
        };
        if (isURL(url)) {
            return url;
        }
        if (isURL(`https://${url}`)) {
            return `https://${url}`;
        }
        if (url.length === 0) {
            return 'https://';
        }
        return url;
    }
    handleSelectPresentationType(type) {
        const { closePopoverModalForm, device, tapBehavior: { url }, updateActivePopover, updateNotificationDeliverable, } = this.props;
        switch (type) {
            case 'IN_APP':
                updateNotificationDeliverable({
                    tapBehavior: {
                        type: 'PRESENT_WEBSITE',
                        url: url ? url : '',
                    },
                });
                break;
            case 'IN_BROWSER':
                updateNotificationDeliverable({
                    tapBehavior: {
                        type: 'OPEN_URL',
                        url: url ? url : 'https://',
                    },
                });
                break;
            default:
        }
        if (device === 'Mobile') {
            closePopoverModalForm();
            setTimeout(() => updateActivePopover(''), 500);
        }
        else {
            updateActivePopover('');
        }
    }
    getClickableView() {
        const { activePopover, device, updateActivePopover } = this.props;
        const popoverProps = {
            placement: 'left',
            overLayClickHandler: () => updateActivePopover(''),
        };
        const getClickable = () => {
            switch (device) {
                case 'Desktop':
                    return (React.createElement(src_1.Button, { text: "Change", type: "regular", mouseDownColors: {
                            active: src_1.turquoise,
                            inactive: src_1.aquamarine,
                        }, key: "presentationType1" }));
                case 'Tablet':
                    return (React.createElement(src_1.ChangeIcon, { fill: src_1.titanium, key: "presentationType1", style: {
                            pointerEvents: 'none',
                        } }));
                case 'Mobile':
                default:
                    return null;
            }
        };
        return (React.createElement(src_1.PopoverContainer, { id: this.POPOVER_ID, popoverProps: popoverProps, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', onClick: () => activePopover === this.POPOVER_ID ? updateActivePopover('') : updateActivePopover(this.POPOVER_ID), showPopover: activePopover === this.POPOVER_ID },
            getClickable(),
            React.createElement("div", { style: {
                    width: 384,
                } }, this.renderWebsitePresentationPopover())));
    }
    renderMobilePopover() {
        const { closePopoverModalForm, isPopoverModalFormOpen, updateActivePopover } = this.props;
        return ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { title: "How should the website be presented?", navbarProps: {
                buttonLeftCallback: () => {
                    closePopoverModalForm();
                    setTimeout(() => updateActivePopover(''), 500);
                },
            }, animation: isPopoverModalFormOpen }, this.renderWebsitePresentationPopover()), document.getElementById('mainModalLeft'));
    }
    getURLForm() {
        const { activePopover, device, selectedTapOption, tapBehavior: { type, url }, updateActivePopover, } = this.props;
        const { urlContentEditable } = this.state;
        return (React.createElement(React.Fragment, null,
            React.createElement(Row_1.default, { onClick: device === 'Tablet'
                    ? () => this.setState({
                        urlContentEditable: true,
                    })
                    : () => null },
                React.createElement("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                    }, onClick: () => this.setState({
                        urlContentEditable: true,
                    }) },
                    React.createElement(src_1.Text, { text: selectedTapOption === 'OPEN_URL' ? 'Which deep link?' : 'Which website?', size: "small", label: true }),
                    React.createElement(src_1.Text, { text: !!url ? url : '', size: "large", contentEditable: urlContentEditable, handleChange: selectedTapOption === 'OPEN_URL' ? this.handleDeepLinkChange : this.handleURLChange, placeholder: true, id: "deeplinkView", onBlurChange: true, placeholderText: `Enter${selectedTapOption === 'PRESENT_WEBSITE' ? ' website' : ' deep link'} URL`, textStyle: { width: '100%' } }))),
            selectedTapOption !== 'OPEN_URL' && (React.createElement(React.Fragment, null,
                React.createElement(Row_1.default, { onClick: () => {
                        updateActivePopover(this.POPOVER_ID);
                    } },
                    React.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                        } },
                        React.createElement(src_1.Text, { text: "How should it be presented?", size: "small", label: true }),
                        React.createElement(src_1.Text, { text: selectedTapOption === 'PRESENT_WEBSITE' && type !== 'OPEN_URL'
                                ? 'Within my app'
                                : 'In a browser', size: "large" })),
                    device !== 'Mobile' && this.getClickableView()),
                activePopover === this.POPOVER_ID && device === 'Mobile' && this.renderMobilePopover()))));
    }
    renderWebsitePresentationPopover() {
        const { device, selectedTapOption, tapBehavior: { type }, } = this.props;
        return (React.createElement(PopoverTextRadioButtonComponent_1.default, { key: "presentationType2", options: {
                IN_APP: 'Within my app',
                IN_BROWSER: 'In a browser',
            }, onClick: this.handleSelectPresentationType, selectedTapOption: selectedTapOption === 'PRESENT_WEBSITE' && type !== 'OPEN_URL' ? 'IN_APP' : 'IN_BROWSER', device: device }));
    }
    render() {
        const { device, selectedTapOption } = this.props;
        switch (selectedTapOption) {
            case 'PRESENT_EXPERIENCE':
                return React.createElement(ExperienceSelector_1.default, { device: device });
            case 'PRESENT_WEBSITE':
            case 'OPEN_URL':
                return this.getURLForm();
            default:
                return React.createElement("div", null);
        }
    }
}
const mapStateToProps = (state) => {
    const { tapBehavior } = reducers_1.getEditableCampaignDeliverable(state);
    return {
        activePopover: reducers_1.getActivePopover(state),
        isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
        tapBehavior,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
        updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
        updateNotificationDeliverable: (d) => {
            dispatch(actions_1.updateNotificationDeliverable(d));
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(TapBehaviorBody);
